import { Card } from '@/ui/primitives';

const etapas = [
  ['Entrada', 'IA lê anexos, identifica produtor, finalidade, cultura/atividade e pendências iniciais.'],
  ['Cadastro', 'Auto preenche dados do processo, instituição Sicoob Credisul, programa/linha, safra e responsáveis.'],
  ['Imóveis/KML', 'Cruza imóvel, CAR, CCIR, CIB, matrícula e glebas KML; sinaliza divergência de área.'],
  ['BACEN/SICOR', 'Sugere código de empreendimento conforme produto, finalidade, modalidade, variedade/cesta/safra e unidade.'],
  ['Orçamento', 'Monta insumos/serviços, produção estimada e preço médio; em bovinos recalcula R$/kg pela arroba.'],
  ['ZARC/ATER', 'Confere necessidade de seguro, ZARC e ATER; destaca campos que dependem de confirmação técnica.'],
  ['Ambiental/ZEE', 'Preenche respostas ambientais com base documental e marca o que precisa validação humana.'],
  ['Documentos', 'Organiza anexos por categoria do fluxo Sicoob e aponta documentos faltantes antes do envio.'],
  ['Parecer/PDF', 'Gera parecer técnico, resumo do projeto e pacote para assinatura/protocolo.'],
  ['Devolutivas', 'Lê notificação da cooperativa, sugere ajuste e registra resposta antes de reenviar.'],
];

export function SicoobCredisulGuide() {
  return (
    <Card padding="md" className="border border-accent/20 bg-accent/5">
      <div className="flex flex-col gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-accent">Automação IA · Sicoob Credisul</p>
          <h2 className="text-base font-semibold text-text">Processo e emissão de documentos com mínima ação humana</h2>
          <p className="text-sm text-text-muted">
            A ação humana fica concentrada em confirmar dados críticos, validar responsabilidade técnica, assinar e enviar/reenviar no fluxo da cooperativa.
          </p>
        </div>
        <div className="grid gap-2 md:grid-cols-2 xl:grid-cols-5">
          {etapas.map(([titulo, texto]) => (
            <div key={titulo} className="rounded-lg border border-border bg-surface px-3 py-2">
              <p className="text-xs font-semibold text-text">{titulo}</p>
              <p className="mt-1 text-xs leading-relaxed text-text-muted">{texto}</p>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
